import { render, staticRenderFns } from "./U.Pattern.Detail.vue?vue&type=template&id=6622a0ef&"
import script from "./U.Pattern.Detail.vue?vue&type=script&lang=js&"
export * from "./U.Pattern.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports